export default __webpack_public_path__ + "static/media/about-image.05c6a6a2.png";